import listtableHelper from './listtableHelper';

export class moneyHelper {
  static toMoneyFormat(moneysum, currencycode) {
    try {
      if (!currencycode || typeof currencycode !== 'string') {
        return `${listtableHelper.valueWithTwoDecimalPlaces(parseFloat(moneysum))}`;
      }
    } catch (err) {
      return `${moneysum} (err)`;
    }
    try {
      //Icon based currency formatter
      // const formatter = new Intl.NumberFormat('en-US', {
      //   style: 'currency',
      //   currency: currencycode,
      //   minimumFractionDigits: 2,
      //   maximumFractionDigits: 2,
      // });

      // return  formatter.format(moneysum);
      return moneyHelper.toUsMoneyFormat(moneysum ?? 0, currencycode);
    } catch (err) {
      return `${moneysum} ${currencycode}`;
    }
  }

  static toUsMoneyFormat(moneysum, currencycode) {
    if (currencycode === '' || currencycode === undefined || currencycode === null) {
      return `${moneysum} err-tumf`;
    }
    // An amount that is not a number at all (a blank cell — the row simply has no value for this
    // column) renders as nothing. Without this it read "USD NaN"; note null/undefined never get
    // here, toMoneyFormat coalesces those to 0 and they keep rendering as "<code> 0.00".
    const parsedMoneySum = parseFloat(moneysum);
    if (isNaN(parsedMoneySum)) {
      return '';
    }
    try {
      return `${currencycode} ${parsedMoneySum
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    } catch (err) {
      return ` ${currencycode} ${moneysum}`;
    }
  }
}

export default moneyHelper;
